import { Grid } from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import { useFormState, useForm } from 'react-final-form';
import { v4 as uuid } from 'uuid';
import _ from 'lodash';

import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalBondManager from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';

export default function SelectManyAwbRangesBondManager({ isConsult }) {
  const form = useForm();
  const { values } = useFormState();

  const listProps = useMemo(
    () => ({
      name: 'awbRanges',
      columns: [
        {
          field: 'inicioAwb',
          headerName: 'Início AWB',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.inicioAwb,
        },
        {
          field: 'finalAwb',
          headerName: 'Final AWB',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.finalAwb,
        },
      ],
    }),
    []
  );

  const formProps = useMemo(
    () => ({
      rootName: 'ignorableFields',
      fields: [
        { name: 'inicioAwb', label: 'Início AWB', required: true },
        { name: 'finalAwb', label: 'Final AWB', required: true },
      ],
    }),
    []
  );

  const handleAdd = useCallback(async (currentVinculo, currentVinculos) => {
    const novo = {
      id: uuid(),
      inicioAwb: currentVinculo?.inicioAwb || '',
      finalAwb: currentVinculo?.finalAwb || '',
    };

    if (_.isArray(currentVinculos)) {
      form.change('awbRanges', [...currentVinculos, novo]);
    } else {
      form.change('awbRanges', [novo]);
    }

    form.change('ignorableFields.inicioAwb', null);
    form.change('ignorableFields.finalAwb', null);
  }, [form]);

  const handleUpdate = useCallback(async (currentVinculo, currentVinculos) => {
    if (!currentVinculo?.id) return;
    if (!_.isArray(currentVinculos)) return;

    const vinculos = [...currentVinculos];
    const index = vinculos.findIndex((el) => el.id === currentVinculo.id);
    if (index === -1) return;

    vinculos[index] = { ...currentVinculo };
    form.change('awbRanges', vinculos);

    form.change('ignorableFields.inicioAwb', null);
    form.change('ignorableFields.finalAwb', null);
  }, [form]);

  const handleAlreadyExists = useCallback(() => false, []);

  return (
    <QCXFinalBondManager
      isParentConsult={isConsult}
      listProps={listProps}
      formProps={formProps}
      handleAdd={handleAdd}
      handleUpdate={handleUpdate}
      handleAlreadyExists={handleAlreadyExists}
      forceShowDelete
    >
      <Grid item xs={12} sm={6} md={6}>
        <QCXFinalTextField
          id="awb-inicio-field"
          key="awb-inicio-field"
          name="ignorableFields.inicioAwb"
          label="Início AWB"
          disabled={isConsult}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6}>
        <QCXFinalTextField
          id="awb-final-field"
          key="awb-final-field"
          name="ignorableFields.finalAwb"
          label="Final AWB"
          disabled={isConsult}
        />
      </Grid>
    </QCXFinalBondManager>
  );
}
